import React from 'react';
import WebStepShell from './WebStepShell';
import DeviceMedia from './DeviceMedia';
import type { WebFlowCtx } from './types';

interface Props {
  ctx: WebFlowCtx;
}

const Step6Done: React.FC<Props> = ({ ctx }) => (
  <WebStepShell
    step="done"
    onCancel={ctx.navigateToDashboard}
    secondary={{ label: 'Add Device', onClick: ctx.navigateToAddDevice }}
    primary={{ label: 'Go to Dashboard', onClick: ctx.navigateToDashboard }}
    media={<DeviceMedia indicator="success" showCheck />}
  >
    <p className="dcfw-eyebrow">SETUP PHASE 6</p>
    <h2 className="dcfw-title">Step 6 of 6: Device connected Successfully</h2>

    <p className="dcf-step-subtitle live">Your device is live!</p>
    <p className="dcf-step-subtitle">
      Your Smart Eco device is now monitoring indoor air quality.
      {ctx.isFirstOnboarding
        ? ' The device is initializing — first readings will appear on your dashboard within 2–3 minutes.'
        : ' Readings will appear on your dashboard shortly.'}
    </p>

    <ul className="dcf-info-list" style={{ marginTop: 8 }}>
      {ctx.isFirstOnboarding && (
        <li className="dcf-info-list__item">
          Device status: <strong>Initializing</strong> — waiting for first data
        </li>
      )}
      <li className="dcf-info-list__item">
        Device will upload readings automatically
      </li>
      <li className="dcf-info-list__item">
        View live data on the Smart Eco dashboard
      </li>
      <li className="dcf-info-list__item">
        Add more devices anytime from the menu
      </li>
    </ul>
  </WebStepShell>
);

export default Step6Done;
